import React from 'react';

import PopupFooter from './PopupFooter';
import Share from './Share';
import tag from './Analytics';


function Success(props) {

  tag('formsuccess');

  // reset wizard on popup close
  const onClose = () => {
    props.onClose();
    props.onReset();
  }

  // is pre-moderation enabled on this contrib ?
  const { moderation = false } = props.addResult;

  return (
    <div class="gp-popup-choix">
      <div class="gp-close-icon" onClick={onClose}>
        <span class="icon">
          <i class="fa fa-window-close"></i>
        </span>
      </div>
      <div class="gp-content1 gp-no-counter">
		<div class="gp-titre-s4">
          Merci pour votre contribution
        </div>
        <div>
          {moderation ? (
            <p>
              Votre témoignage apparaîtra sur la carte des témoins
              du climat dès qu'il aura été validé par nos équipes.
            </p>
          ) : (
            <p>
              Votre témoignage apparaîtra dans quelques heures
              sur la carte des témoins du climat.
            </p>
          )}
        </div>
        <div>
          <p>
            Faites passer le mot sur les réseaux sociaux :
          </p>
          <Share/>
        </div>
      </div>
    </div>
  )
}

export default Success;
